/**
 * Portal addresses shared by the router, the navigation and the sign-in return.
 *
 * The server answers a fresh load of / with the public landing page (server/src/index.ts), which compliance
 * reviewers and visitors without an account see. The signed-in dashboard therefore lives at /dashboard, so a
 * reload of it stays in the portal (PORTAL-RELOAD-1, BL-76e772dc). Inside the app, / still redirects here.
 */
export const DASHBOARD_PATH = '/dashboard';
